exports.NOTIFICATIONSERVICETYPES = {
    EMAIL: 'email',
    EMAIL_MG: 'email_mg', // mailgun template based emails
    SMS: 'sms',
    IN_APP: 'inapp',
    IVRS: 'ivrs',
    PUSH_NOTIFICATION: 'pushnotification',
    WEB_NOTIFICATION: 'webnotification',
}
